module.exports = __webpack_public_path__ + "assets/img/启动快，占用小.b382713d.jpg";